import axios from "axios";
import store from '../store/index.js'

class Api {
  /**
   * @param {import('axios').AxiosStatic} axios 
   */
  constructor(axios){
    this._axios = axios
    this._access_token = store.getters['accessToken']
    this._configAxios();
  }
  
  /**
   * 
   * @param {string} token - Bearer {token}
   */
  setToken(token) {
    this._access_token = token
  }

  _configAxios() {
    this._axios.interceptors.request.use(
      async config => {
        if (this._access_token) {
          config.headers = { 
            'Authorization': `Bearer ${this._access_token}` //set token when consumed API
          }
        }
        return config;
      },
      error => {
        Promise.reject(error)
      });
      
      this._axios.interceptors.response.use((response) => {
        return response
      }, async (error) => {
      if(error.response.status === 401 && error.response.data?.message?.toLowerCase() === "token expired" && window.location.pathname !== "/login") {
        store.dispatch('clearAll')
        store.commit('setSessionExpired', true)
        return window.location.href = "/login"
      }
      return Promise.reject(error);
    });
  }
}

export { Api }